<template>
  <basic-page>
    <a-col :span="24" slot="header">
      <relation-list :list="relationlist" @changelist="changeList">
      </relation-list>
    </a-col>

    <a-row slot="content">
      <bidding v-if="type == 'bid' " @checked="selectedItem" @search="search" :key="refresh" :postdata="postdata" :result="result" :relationitem="relationItem"/>
      <ent v-if="type == 'ent' " @checked="selectedItem" @search="search" :key="refresh" :postdata="postdata" :result="result" :relationitem="relationItem"/>
    </a-row>

    <a-col :span="24" slot="loadmore" v-if="result.length > 0">
      <a-row>
        <a-button @click="loadMore">加载更多</a-button>
      </a-row>
    </a-col>

    <a-col :span="24" slot="relation" v-if="doRelation">
      <relation-tab :items="relations" @computerelation="computeRelation" @deleteitem="deleteRelationItem"/>
    </a-col>
  </basic-page>
</template>

<script>
import BasicPage from '@/layout/BasicPage.vue'
import {RelationList, RelationTab} from '@/com/Relation'
import Bidding from '@/com/Bidding/Bidding.vue'
import Ent from '@/com/Ent/Ent.vue'

import {relations} from '@/util/config'

export default {
  name: 'BiddingMain',
  data() {
    return {
      tab: 'bid',
      type: '',
      position: 0,
      relationlist: [{ name: '标讯', tab: 'bid'}],
      relationItem: {},
      postdata: [],
      result: [],
      doRelation: false,
      relations: relations['bid'],
      refresh: 1
    }
  },
  components: {
    BasicPage,
    RelationList,
    RelationTab,
    Bidding,
    Ent
  },
  methods: {
    changeList: function(index) {
      this.$store.commit('changeposition', index)
      this.position = this.$store.getters.getPosition()

      this.postdata = this.$store.getters.getPostdata()
      this.result = this.$store.getters.getResult()
      this.relationItem = this.$store.getters.getRelationItem()

      this.relationlist = this.$store.getters.getRelationList()
      this.type = this.relationlist[this.position].tab
      let tag = false
      for (let i = 0; i < this.result.length; i++) {
        if (this.result[i].checked) {
          tag = true
          break
        }
      }
      if (tag) {
        this.doRelation = true
      } else {
        this.doRelation = false
      }
      this.refresh += 1
    },
    deleteRelationItem: function() {
      this.relationItem = this.$store.getters.getRelationItem()
      this.refresh += 1; 
      this.selectedItem(this.relationItem); 
    },
    computeRelation: function(data) {
      let relationItem = this.$store.getters.getRelationItem()

      let name = data.name
      let tab = data.tab
      let fromType = this.relationlist[this.position].tab

      let list = []
      for (let i = 0; i <= this.position; i++) {
        list.push(this.relationlist[i])
      }
      this.relationlist = list

      this.relationlist.push({name: name, tab: tab})
      this.$store.commit('updaterelationlist', this.relationlist)
      this.$store.commit('addposition')

      this.position = this.$store.getters.getPosition()
      this.relationlist = this.$store.getters.getRelationList()
      this.type = this.relationlist[this.position].tab
      
      let toType = this.relationlist[this.position].tab

      let basic = relations[fromType]

      let task = ""
      let field = ""
      for (let i = 0; i < basic.length; i++) {
        if (basic[i].tab == toType) {
          task = basic[i].task 
          field = basic[i].field
          break
        }
      }

      let postdata = {
        task: task,
        'api-path': 'relation'
      }
      let names = ""
      for (let key in this.relationItem) {
        names = names + key + " "
      }
      postdata[field] = names
      postdata['from'] = 0
      postdata['to'] = 20
      postdata['page'] = 1

      this.relationItem = {};

      let that = this;
      let loading = that.$message.loading("搜索中...", 0);
      that.postdata = postdata
      that.post(postdata["api-path"], that.postdata)
        .then(function(data) {
          that.result = data.data;
          setTimeout(loading, 0);
          that.doRelation = false;
          that.$store.commit('updatepostdata', {post: that.postdata, tab: 'bidding'});
          that.$store.commit('updateresult', {result: that.result, tab: 'bidding'});
          that.relationItem = {};
          that.$store.commit('updaterelationitem', that.relationItem);
          that.refresh += 1;
        }).catch(function (e) {
          setTimeout(loading, 0);
          that.$message.error("查询失败");
      });

    },
    selectedItem: function(data) {
      let n = 0;
      for(let key in data) {
        n = n + 1;
      }
      if ( n > 0 ) {
        this.doRelation = true
      } else {
        this.doRelation = false
      }
      //this.refresh += 1
    },
    search: function(postdata, result) {
      this.posdata = postdata
      this.result = result
      this.refresh += 1
    },
    loadMore: function() {
      this.postdata = this.$store.getters.getPostdata()
      let currentPage = this.postdata.page + 1;
      this.postdata.page = currentPage;
      let from = (currentPage - 1) * 20;
      let to = (currentPage) * 20;
      this.postdata["from"] = from;
      this.postdata["to"] = to;
      let that = this;
      let loading = that.$message.loading("搜索中...", 0);
      that.post(that.postdata["api-path"], that.postdata)
        .then(function(data) {
          for(let i = 0; i < data.data.length; i++) {
            that.result.push(data.data[i]);
          }
          setTimeout(loading, 0);
          that.$store.commit('updatepostdata', {post: that.postdata, tab: 'bidding'});
          that.$store.commit('updateresult', {result: that.result, tab: 'bidding'});
          that.refresh += 1;
        }).catch(function (e) {
          setTimeout(loading, 0);
          that.$message.error("查询失败");
      });
    }
  },
  created() {
    this.$store.commit('changetab', this.tab)
    let l = this.$store.getters.getRelationList()
    if (l.length == 0) {
      this.$store.commit('updaterelationlist', this.relationlist)
    }
    this.position = this.$store.getters.getPosition()
    this.relationlist = this.$store.getters.getRelationList()
    this.postdata = this.$store.getters.getPostdata()
    this.result = this.$store.getters.getResult()
    this.relationItem = this.$store.getters.getRelationItem()
    this.type = this.relationlist[this.position].tab
    for (let i = 0; i < this.result.length; i++) {
      if (this.result[i].checked) {
        this.doRelation = true
        break
      }
    }
  }
}
</script>

<style>
</style>
